import Vue from 'vue';
import Vuex from 'vuex';
import loading from './modules/loading';
import uLoginInfo from './modules/user/login_info';
import uItemList from './modules/user/item_list';
import uHistory from './modules/user/history';
import uCart from './modules/user/cart';
import uMaster from './modules/user/master';
import mLoginInfo from './modules/manage/login_info';
import mOrderList from './modules/manage/order_list';
import mCustomerList from './modules/manage/customer_list';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    loading,
    uLoginInfo,
    uItemList,
    uHistory,
    uCart,
    uMaster,
    mLoginInfo,
    mOrderList,
    mCustomerList,
  },
});

export default store;
